<template>
  <landing-page
    label="corporate.corporate"
    description="corporate.corporateDesc"
    labelColor="#8F8248"
    descColor="#8F8248"
    :eggImgObj="{ componentName: 'corporate', imgName: 'corporateIntro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />

  <!--<TitleWStar title="corporate.corporate" 
  titleColor="sea-blue" 
  :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBlue', imgFormat: 'svg' }" 
  />
  change obj to constant?-->
</template>

<script setup lang="ts">
import { useCorporateStore } from "@/stores/corporate";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const corporateStore = useCorporateStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>